module.exports = __webpack_public_path__ + "media/img/sbt-test/Scholarships2u-SBT-a237fb9661d5bbc9f5d90984a8b6ed50.jpg";